declare const window: any;

import { loadJs } from './utilities'

const url = 'https://scdn.cxense.com/cx.js'

const EVENTS = {
	CX_LOADED: 'mega.cxense.loaded'
}

export function load(callback:Function = ()=>{}) {
    window.cX = window.cX || { options: { tcf20: true } }
    window.cX.callQueue = window.cX.callQueue || []
    window.cX.callQueue.push(['sendPageViewEvent'])

	loadJs(url, () => { dispatchEvent(new CustomEvent(EVENTS.CX_LOADED)), callback() })
}